import React, { Fragment, useContext, useEffect, useState } from "react";
// Provider
import { AppContext, LOG_IN_FAILURE, LOG_IN_SUCCESS, MENU_SET_ALL, SET_APP_ALL, SocketCommand, socketManager } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { openLayerFn } from "../Layout";

import {
  PostAcntChrg,
  PostApi101,
  PostApi102Sns,
  PostApi154,
  PostApi1910,
  PostApi1913,
  PostApiGetNewPoint,
} from "../../modules/network/padoPost";

import { AlertLayer } from "../../components/UI/Dialog";

import { Base64 } from "js-base64";

import { NativeAction } from "../../modules/utils/HandleWs";
import { getCookie, setCookie } from "../../modules/utils/cookie";
import { ExistIdLayer } from "../common/Modal/ExistIdLayer";
import { SET_MENU_NEW_REPORT_LIST } from "./../../components/AppProvider";
import { loginLogInterface } from "./Login";

let URL = [
  "/",
  "/SM",
  "/sm/bp/input",
  "/sm/bs/input",
  "/eocs",
  "/surround",
  "/eocs",
];

export default props => {
  const { cfg, auth, dispatch, phonecfg, userinfo } = useContext(AppContext);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [dupList, setDupList] = useState("");
  const [registState, setRegistState] = useState(false);

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleLoginFail = () => {
    // handleReset();
    dispatch({ type: LOG_IN_FAILURE });
    handleAlert("확인", "로그인 실패");
  };

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const request1910 = (userinfo, cardType) => {
    PostApi1910(userinfo, cfg, phonecfg, cardType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;

          if (data.length > 0)
            dispatch({ type: MENU_SET_ALL, menutype: cardType, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  const request1913 = userinfo => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          dispatch({ type: SET_APP_ALL, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request101 = acntData => {
    const snsInfo = acntData ? acntData : getCookie("snsInfo");

    PostApi101(
      phonecfg,
      cfg,
      snsInfo[0].userEmail,
      null,
      snsInfo[0].UID,
      snsInfo[0].signUpChannel
    )
      .then(res => {
        if (res.resultCode === "000") {
          setLoginSuccess(true);
          handleLoginSuccess(res);
          setCookie("lastLoginChannel", res.result[0].signUpChannel, 365);
        } else if (res.resultCode === "001") {
          if (props.match.params.info) {
            let userInfo = JSON.parse(Base64.decode(props.match.params.info));
            setCookie("userInfo", userInfo, 1);

            let signUpChannel = getCookie("signUpChannel");

            request150(
              userInfo.userDI,
              userInfo.userName.trim(),
              signUpChannel
            );
          }
        } else {
          setLoginSuccess(false);
          handleLoginFail();
        }
      })
      .catch(err => {
        console.log("err :: ", err);
        setLoginSuccess(false);
        handleLoginFail();
      });
  };

  const request102 = (userEmail, userName, signUpChannel, UID, userInfo) => {
    PostApi102Sns(
      phonecfg,
      cfg,
      userEmail.trim(),
      userName.trim(),
      signUpChannel,
      UID,
      userInfo
    )
      .then(res => {
        if (res.resultCode === "000") {
          if (res.result === 1) {
            // 회원가입 성공 & 로그인 처리
            // request101(userEmail, userName, UID, signUpChannel);
            request101();
          } else {
            console.log("회원가입 실패");
          }
        } else {
          console.log("err========" + res.err);
        }
      })
      .catch(err => {
        console.log(err);
        handleRegistError();
      });
  };

  const requestGetNewPoint = userinfo => {
    PostApiGetNewPoint(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultCode === "E000") {
          dispatch({ type: SET_MENU_NEW_REPORT_LIST, data: res.result });
        } else {
          console.log("Interface Fail");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleLoginSuccess = res => {
    const autoLogin = getCookie("isAutologin");

    dispatch({
      type: LOG_IN_SUCCESS,
      data: res.result[0],
      isAutoLogin: autoLogin === "false" ? false : true,
    });
    loginLogInterface(
      res.result[0],
      phonecfg,
      cfg,
      "I",
      "M",
      res.result[0].signUpChannel
    );

    request1910(res.result[0], "");
    request1913(res.result[0]);
    requestGetNewPoint(res.result[0]);
    // 전체 가져오기 수정 필요
    if (res.result[0].isAuthOk == "0") {
      // 향후 수정 필요 임시임(DSRYU) 메세지 매번 보여줄 필요 없음 처리
      $("#exchangeTargetLogin").attr("id", "welcomeLogin");
      handleAlert("확인", `케어포미에 오신 것을 환영합니다.`);
      if (
        phonecfg.phoneOS === "IOS" &&
        parseInt(phonecfg.version.split(".")[2]) > 13
      ) {
        NativeAction(phonecfg, "inputEPmenu", "in");
      }
    } else {
      // 로그인 이후 본인인증 여부에 따라
      _O.OpenMenu("/membership/certification");
    }
  };

  const handleAlertCB = () => {
    if (loginSuccess) {
      _O.OpenMenu("/");
    } else {
      _O.OpenMenu("/membership/login");
    }
  };

  const handleDuplicateMember = userId => {
    let viewId;
    viewId = userId.split("@");
    // handleAlert('회원가입', '이미 등록된 회원입니다.<br />' + viewId[0].slice(0, -2) + '**'  + '@' + viewId[1], '/membership/login');
    openLayerFn($("#existLayer"));
  };

  const handleRegistError = () => {
    handleAlert("회원가입", "회원가입 실패하였습니다.");
  };

  const requestAcntCharg = (userInfo, snsInfo, getUserInfo) => {
    PostAcntChrg({ userToken: getUserInfo.userToken }, cfg, {
      signUpChannel: snsInfo[0].signUpChannel,
      UID: snsInfo[0].UID,
      userNm: userInfo.userName,
      userBirthDt: userInfo.userBirth,
      userTelNo: userInfo.userPhone,
      userDI: getUserInfo.userDI,
      userEmail: snsInfo[0].userEmail,
    })
      .then(res => {
        if (res.rsltCd === "E000") {
          request101();
        } else {
          alert("계정정보 업데이트 실패");
        }
      })
      .catch(err => {
        console.log("PostAcntChrg ERR:: ", err);
      });
  };

  const request150 = (userDI, userName, signUpChannel) => {
    const snsInfo = getCookie("snsInfo");
    const userInfo = JSON.parse(Base64.decode(props.match.params.info));

    // 중복가입 계정 확인
    PostApi154(
      phonecfg,
      cfg,
      userInfo.userName,
      userInfo.userPhone,
      userInfo.userBirth,
      userInfo.Gender,
      userInfo.userDI,
      "",
      userInfo.isForeigner
    )
      .then(res => {
        if (res.resultCode === "000") {
          if (res.joinInfo.length > 0) {
            requestAcntCharg(userInfo, snsInfo, res.joinInfo[0]);
          } else {
            // 회원가입 프로세스 진행
            request102(
              snsInfo[0].userEmail,
              userInfo.userName,
              snsInfo[0].signUpChannel,
              snsInfo[0].UID,
              userInfo
            );
          }
        }
      })
      .catch(err => {
        console.log(err);
        handleRegistError();
      });
  };

  const openWebSocket = () => {
    if (phonecfg.phoneOS == "IOS") {
      socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
      // socketManager(SocketCommand.GET_GPS_INFO, undefined);
    } else {
      // 임시방편
      socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
      // socketManager(SocketCommand.GET_PHONE_INFO, undefined);
    }
  };

  useEffect(() => {
    if (phonecfg.phoneToken == "123" || phonecfg.version == "2.0.0") {
      openWebSocket();
    } else {
      if (!registState) {
        setRegistState(true);
        request101();
      }
    }
  }, [phonecfg]);

  return (
    <Fragment>
      <div></div>
      {/* <Loading /> */}

      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertCB}
      />

      <ExistIdLayer dupList={dupList} />
    </Fragment>
  );
};